import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';
import * as _ from 'lodash';
import { RadioButtonOption } from './p-field-radio';

@Component({
    selector: 'p-field-radio',
    template: `
        <p-field [isMandatory]="mandatory" [label]="label" [labelTooltip]="labelTooltip" [isReadOnly]="isReadOnly">
            <mat-radio-group class="p-radio-group p-paragraph-1" slot="editMode">
                <!--<label *ngIf="label && showLabelOnTop" class="p-radio-group-label p-radio-button">{{label}}</label>-->

                <mat-radio-button
                    class="p-radio-group-option p-radio-button p-radio-option"
                    [ngClass]="{ inline: inLine }"
                    *ngFor="let option of options"
                    [value]="option[idField]"
                    [disabled]="option.disabled || isDisabled"
                    [checked]="option[idField] == value"
                    (change)="changeValue(option[idField])"
                    [attr.name]="identifier"
                    [attr.id]="identifier + option[idField]"
                    [attr.automation-id]="'radio_option-' + (option[nameField] || option[idField])"
                >
                    <ng-container *ngTemplateOutlet="itemTmpl || defaultTmpl; context: { $implicit: option }"></ng-container>
                </mat-radio-button>
            </mat-radio-group>

            <mat-radio-group class="p-radio-group p-paragraph-1" slot="readMode" [disabled]="true">
                <!--<label *ngIf="label && showLabelOnTop" class="p-radio-group-label p-radio-button">{{label}}</label>-->

                <mat-radio-button
                    class="p-radio-group-option p-radio-button"
                    [ngClass]="{ inline: inLine }"
                    *ngFor="let option of options"
                    [value]="option[idField]"
                    [disabled]="true"
                    [checked]="option[idField] == value"
                >
                    <ng-container *ngTemplateOutlet="defaultTmpl; context: { $implicit: option }"></ng-container>
                </mat-radio-button>
            </mat-radio-group>
        </p-field>

        <ng-template #defaultTmpl let-option>
            <div class="p-radio-button-line">
                {{ option[nameField] }}
            </div>
        </ng-template>
    `,
    styleUrls: ['./p-field-radio.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldRadioComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldRadio'
})
export class PFieldRadioComponent extends PFieldAbstractComponent<string | number | boolean> {
    @Input() label?: string;

    @Input() mandatory = false;
    @Input() itemTmpl?: TemplateRef<any>;

    @Input() options?: RadioButtonOption[];
    @Input() idField: string = 'id';
    @Input() nameField: string = 'name';
    @Input() inLine = false;

    @Input() showLabelOnTop = false;

    identifier = _.uniqueId('p-field-radio');

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    protected changeValue(v: string | number | undefined): void {
        this.markAsTouched();

        if (!this.isReadOnly) {
            this.value = v;
            this._onChange(this.value);
        }
    }
}
